// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3djGd","select":"styles_select__1QoeC"};